module.exports = __webpack_public_path__ + "assets/img/C2.ab610e63.png";